<div class="atg-price-list-container position-relative" *ngIf="isPriceListAllowed">
    <div class="rounded w-100 float-left mb-3">
        <div class="w-100 customersearch-title">
            {{ pageTitle$ | async }}
        </div>
    </div>
    <div class="atg-success-popup-backdrop" *ngIf="submitRequestSuccessMessage">
        <div class="atg-success-popup" role="dialog" aria-modal="true" [attr.aria-label]="'atgPriceList.popupAriaLabel' | cxTranslate">
            <button type="button" class="atg-success-popup-close" [attr.aria-label]="'atgPriceList.close' | cxTranslate"
                (click)="closeSubmitRequestSuccessPopup()">
                <i class="fas fa-times" aria-hidden="true"></i>
            </button>
            <div class="atg-success-popup-text">{{ submitRequestSuccessMessage }}</div>
        </div>
    </div>

    <div class="col-lg-12 bg-white p-0 float-left mb-3 border-bottom" *ngIf="tableRows.length > 0">
        <div class="customersearch-list-table mt-3 float-left col-lg-12 p-0">
            <div
                class="customersearch-list-titles atg-price-list-header border-top border-bottom float-left w-100 pl-2 pr-2 pt-3 pb-3">
                <div class="col-md-2 padding-res-0 float-left font-text-600">{{ 'atgPriceList.customerName' | cxTranslate }}</div>
                <div class="col-md-3 float-left font-text-600">{{ 'atgPriceList.salesArea' | cxTranslate }}</div>
                <div class="col-md-2 float-left font-text-600">{{ 'atgPriceList.number' | cxTranslate }}</div>
                <div class="col-md-2 float-left font-text-600">{{ 'atgPriceList.date' | cxTranslate }}</div>
                <div class="col-md-3 float-left font-text-600"></div>
            </div>

            <div class="bg-white customersearch-list-titles table-content border-bottom float-left w-100 p-2 font-weight-normal d-flex align-items-center"
                *ngFor="let row of tableRows" [attr.aria-hidden]="true">
                <div class="col-md-2 title-wrap padding-res-0 float-left">
                    <span class="res-titles">{{ 'atgPriceList.customerName' | cxTranslate }}:</span> {{ row.customerName }}
                </div>
                <div class="col-md-3 title-wrap float-left" (click)="$event.stopPropagation()"
                    (keyup)="$event.stopPropagation()" tabindex="0"
                    style="overflow: visible !important; position: relative;">
                    <span class="res-titles">{{ 'atgPriceList.salesArea' | cxTranslate }}:</span>
                    <ng-select [items]="row.salesAreaOptions" bindLabel="label" bindValue="value"
                        [(ngModel)]="row.selectedSalesArea" [searchable]="false" [clearable]="false"
                        [placeholder]="'atgPriceList.selectSalesArea' | cxTranslate" [disabled]="!row.hasData" class="sales-area-dropdown"
                        (click)="$event.stopPropagation()" [appendTo]="'body'">
                    </ng-select>
                </div>
                <div class="col-md-2 title-wrap float-left">
                    <span class="res-titles">{{ 'atgPriceList.number' | cxTranslate }}:</span> {{ row.number }}
                </div>
                <div class="col-md-2 title-wrap float-left" [formGroup]="row.dateForm">
                    <span class="res-titles">{{ 'atgPriceList.date' | cxTranslate }}:</span>
                    <div class="input-group valid-to position-relative">
                        <input class="form-control form-control-md cursor-pointer" [placeholder]="knBrDateFormatService.getDateFormat()"
                            ngbDatepicker #d="ngbDatepicker" container="body" formControlName="date" [minDate]="minDate" />
                        <div class="input-group-append">
                            <button type="button" class="btn calendar p-0 h-auto w-auto"
                                (click)="d.toggle()">
                                <i class="far fa-calendar-alt color-font"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 title-wrap float-left d-flex gap-2 flex-wrap">
                    <button type="button" class="btn btn-primary"
                        [disabled]="!row.hasData || !hasValidSalesArea(row.selectedSalesArea) || !getRowDate(row) || isAnyActionLoading"
                        (click)="onSubmitNewRequest(row)">{{ 'atgPriceList.submitNewRequest' | cxTranslate }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="atg-loading-overlay" *ngIf="isAnyActionLoading" aria-live="polite" aria-busy="true">
        <div class="atg-loading-content">
            <cx-spinner></cx-spinner>
        </div>
    </div>
</div>